var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "al-card",
    class: {
      'al-card--still': _vm.still
    }
  }, [_c('img', {
    staticClass: "al-card__logo",
    attrs: {
      "src": "statics/images/logo-greenmapper-download-trans.png",
      "alt": "GreenMapper"
    }
  }), _c('div', {
    staticClass: "al-card__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.failed ? void 0 : _vm.look === 'atlas' ? _c('div', {
    staticClass: "al-card__scale",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l(_vm.steps, function (step) {
    return _c('span', {
      key: step.key,
      class: {
        'is-done': step.state === 'done'
      }
    });
  }), 0) : _c('div', {
    staticClass: "al-card__bar",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    style: {
      transform: 'scaleX(' + _vm.progress + ')'
    }
  })]), !_vm.failed ? _c('ul', {
    staticClass: "al-card__steps"
  }, _vm._l(_vm.steps, function (step, i) {
    return _c('li', {
      key: step.key,
      class: 'is-' + step.state,
      style: {
        '--i': i
      }
    }, [_c('span', {
      staticClass: "al-mark",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('span', {
      staticClass: "al-mark__ring"
    }), _c('span', {
      staticClass: "al-mark__arc"
    }), _c('span', {
      staticClass: "al-mark__fill"
    }), _c('svg', {
      staticClass: "al-mark__tick",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": "M6 12.5l4 4 8-9"
      }
    })])]), _c('span', {
      staticClass: "al-card__label"
    }, [_vm._v(_vm._s(step.label))]), _vm.counted ? _c('span', {
      staticClass: "al-card__count"
    }, [_vm._v(_vm._s(step.state === 'done' ? step.count || '' : ''))]) : _vm._e()]);
  }), 0) : _vm._e(), _vm._t("default")], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };